import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, watch } from 'vue'

import { useIFrameAPIConnector } from '@/popup/compositions/useIFrameAPIConnector'
import { EXTENSION_ORIGIN } from '@/shared/config'
import { getURL } from '@/shared/popup'
import {
  Transaction,
  TransactionChangeMessage,
  TransactionComponent,
} from '@/shared/models/Transaction'
import { useAppStore } from '@/popup/store/AppStore'
import { Approval, ApprovalApi } from '@/shared/apis/approvals'
import { useApprovalsStore } from '@/popup/store/ApprovalsStore'
import { GlobalDatabase } from '@/popup/storage/Database'
import { usePreferencesStore } from '@/popup/store/PreferencesStore'
import { ControllerDTO } from '@/business-logic/profile'
import { useProfileStore } from '@/popup/store/ProfileStore'

type Props = {
  transaction: Transaction
  components?: TransactionComponent[]
}

type Dimension = {
  width: number
  height: number
}

type Emits = {
  (event: 'on-loaded'): void
  (event: 'on-resize', dimension: Dimension): void
  (event: 'on-transaction-change', message: TransactionChangeMessage): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionIframe',
  props: {
    transaction: {},
    components: {}
  },
  emits: ["on-loaded", "on-resize", "on-transaction-change"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const appStore = useAppStore()
const approvalsStore = useApprovalsStore()
const profileStore = useProfileStore()
const preferences = usePreferencesStore()

const controllers = ref<ControllerDTO[]>()
watch(
  () => profileStore.controllers,
  async newControllers => {
    controllers.value = newControllers
  },
  { immediate: true }
)

const approval = approvalsStore.getApproval(
  props.transaction?.requestId
) as Approval<keyof ApprovalApi, Transaction>

const iframeSource = getURL() + '/iframe.html#'

const iframeRef = ref<InstanceType<typeof HTMLIFrameElement>>()
const { events, post } = useIFrameAPIConnector('host', {
  id: EXTENSION_ORIGIN,
  iframeRef,
  remoteUrl: '*',
})

events.on('on-transaction-change', (event: TransactionChangeMessage) => {
  emits('on-transaction-change', event)
})

events.on('on-resize', (event: Dimension) => {
  const myele = document.querySelector('#componentIFrame') as HTMLElement
  myele.style.height = `${event.height}px`
  myele.style.opacity = '1'
  emits('on-resize', event)
})

const loadComponents = async () => {
  const componentIFrame = document.querySelector(
    '#componentIFrame'
  ) as HTMLIFrameElement
  if (
    componentIFrame &&
    componentIFrame.contentWindow &&
    props.components &&
    props.components.length > 0
  ) {
    const network = await GlobalDatabase.getNetwork(appStore.network.id)
    post(
      'data',
      {
        transaction: {
          ...props.transaction,
          components: props.components,
        },
        currentProfile: appStore.currentProfile,
        approval,
        controllers: controllers.value,
        rpcUrl: network?.http.url,
        networkId: appStore.network.id,
        preferences: preferences.$state,
      },
      componentIFrame.contentWindow
    )
  }
  events.on('loadedComponent', () => {
    emits('on-loaded')
  })
}

return (_ctx: any,_cache: any) => {
  return (_ctx.components && controllers.value)
    ? (_openBlock(), _createElementBlock("iframe", {
        key: 0,
        id: "componentIFrame",
        ref_key: "iframeRef",
        ref: iframeRef,
        class: "iframe",
        src: iframeSource,
        sandbox: "allow-scripts",
        allow: "clipboard-write",
        "data-testid": "iframe",
        onLoad: loadComponents
      }, null, 544 /* NEED_HYDRATION, NEED_PATCH */))
    : _createCommentVNode("v-if", true)
}
}

})